/* eslint-disable */
import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import SideBar from '../../SideBar'
import Swal from 'sweetalert2'
import apiInstance from '../../../../utils/api'

function Category() {
    const [category, setCategory] = useState([])
    const [code, setCode] = useState('')
    const [amount, setAmount] = useState('')
    const [flag, setFlag] = useState('')
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [showUpdate, setShowUpdate] = useState(false)
    const [updateDataList, setUpdateDataList] = useState([])
    const [upCode, setUpCode] = useState('')
    const [upName, setUpName] = useState('')
    const [upDesc, setUpDesc] = useState('')
    const [upAmount, setUpAmount] = useState('')
    const [upFlag, setUpFlag] = useState('')
    const [upFlagID, setUpFlagID] = useState('')
    const [check, setCheck] = useState('')
    const [upCheck, setUpCheck] = useState('')

    const [Id, setId] = useState('')

    const handleDelete = event => {
        apiInstance
            .delete(
                'reagent-category/' +
                event
            )
            .then(response => {
                Swal.fire({
                    title: 'Success',
                    text: 'Successfully Deleted!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 2000
                })
                const result = category.filter(item => item._id !== event)
                setCategory(result)
            })
            .catch(error => {
                Swal.fire({
                    title: 'Error',
                    text: error.response.data.message,
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 2000
                })
            })
    }

    const handleUpdate = event => {
        console.log(event, 'event')
        const getCatUpdate = async () => {
            try {
                const res = await apiInstance.get(
                    'reagent-category/' +
                    event
                )
                console.log(res.data.data)
                const DetailData = res.data.data[0]
                setUpCode(DetailData.code)
                setUpName(DetailData.name)


                setUpDesc(DetailData.description)
            } catch (err) { }
        }
        getCatUpdate()
        setShowUpdate(true)
        setId(event)
    }

    const CategoryUpdate = () => {
        const data = {
            id: Id,
            code: upCode,
            name: upName,
            description: upDesc
        }


        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        apiInstance
            .put(
                'reagent-category',
                // 'http://localhost:9000/api/category',
                data,
                config
            )
            .then(function (response) {
                Swal.fire({
                    title: 'Successful!',
                    text: 'Successfully Updated',
                    icon: 'success',
                    // showCancelButton: true,

                    showConfirmButton: false,
                    timer: 2000
                })
                setCategory(
                    [...category, res.data.data]
                )

            })
            .catch(function (err) {
                Swal.fire({
                    title: 'Something Wrong!',
                    text: 'Try again, Please.',
                    icon: 'warning',
                    // showCancelButton: true,

                    cancelButtonText: 'Close'
                })
            })
        setShowUpdate(false)
        // document.getElementById('udesc').value = ''
        // document.getElementById('uname').value = ''
        // document.getElementById('ucode').value = ''
        // document.getElementById('uamount').value = ''
        //document.getElementById('flag').value = ''
    }

    const CategoryCreate = () => {
        const data = {
            // code: code,
            name: name,
            amount: amount,
            flag: flag,
            createAcc: check,
            description: description
        }
        //alert(JSON.stringify(data));
        if (code) {
            data.code = code;
        } else {
            data.code = uniqueId
        }

        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        apiInstance
            .post(
                'reagent-category',
                //'http://localhost:9000/api/category',
                data,
                config
            )
            .then(function (response) {
                Swal.fire({
                    title: 'Success',
                    text: 'successfully Registered!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 2000
                })
                // clearForm()
                setCategory([...category, response.data.data])
            })
            .catch(function (err) {
                //alert(err.message)
                Swal.fire({
                    title: 'Error',
                    text: 'Cannot Register!',
                    icon: 'error',
                    confirmButtonText: 'CANCEL'
                })
            })
        // document.getElementById('cdesc').value = ''
        // document.getElementById('cname').value = ''
        // document.getElementById('ccode').value = ''
        // document.getElementById('camount').value = ''
    }
    const uniqueId = parseInt(Date.now() * Math.random())

    useEffect(() => {
        const getCategory = async () => {
            try {
                const res = await apiInstance.get(
                    'reagent-category'
                )

                setCategory(res.data.data)
            } catch (err) { }
        }
        getCategory()
    }, [])

    const clearTextBox = textboxId => {
        const textbox = document.getElementById(textboxId)
        if (textbox && textbox.value) {
            textbox.value = ''
        }
    }



    return (
        <div classNameName='App'>
            {/* <!-- end preloader --> */}
            {/* @include('sweet::alert') */}

            <div className='wrapper'>
                {/* <!-- Navbar --> */}

                {/* <!-- Main Sidebar Container --> */}
                <SideBar />

                {/* <!-- Content Wrapper. Contains page content --> */}

                <div className='content-wrapper'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-12'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item'>
                                            <a href='/'>Home</a>
                                        </li>
                                        <li className='breadcrumb-item active'>
                                            Reagent Category List
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}

                    <section className='content'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-9'>
                                    <div className='card'>
                                        <div className='card-header'>
                                            {/* <h3 className="card-title">Cost Center List</h3> */}
                                        </div>
                                        <div className='card-body'>
                                            <table id='example1' className='table'>
                                                <thead className='text-center '>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Code</th>
                                                        <th>Name</th>

                                                        <th>Description</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                {category.map((cat, i) => (
                                                    <tbody className='text-center'>
                                                        <tr>
                                                            <td>{++i}</td>
                                                            <td>{cat.code}</td>
                                                            <td>{cat.name}</td>

                                                            <td>{cat.description}</td>
                                                            <td>
                                                                <div className='row d-flex justify-content-center'>
                                                                    <div className='col-3'>

                                                                        <button
                                                                            className='btn btn-sm btn-warning'
                                                                            onClick={e => handleUpdate(cat._id)}
                                                                        >
                                                                            Update
                                                                        </button>
                                                                    </div>
                                                                    <div className='col-3'>

                                                                        <button
                                                                            className='btn btn-sm btn-danger'
                                                                            onClick={e => handleDelete(cat._id)}
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {showUpdate ? (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h5 className='card-header mb-4 fw-5 text-secondary'>
                                                Update Category
                                            </h5>
                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Code
                                                </label>
                                                <input
                                                    type='text'
                                                    id='ucode'
                                                    class='form-control border-info'
                                                    name='ucode'
                                                    value={upCode}
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={e => setUpCode(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Name
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='uname'
                                                    id='uname'
                                                    value={upName}
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={e => setUpName(e.target.value)}
                                                />
                                            </div>




                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='udesc'
                                                    name='udesc'
                                                    value={upDesc}
                                                    //   ref={(el) => (this.description = el)}
                                                    onChange={e => setUpDesc(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary form-control text-center fw-5'
                                                id='submit'
                                                onClick={CategoryUpdate}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h5 className='card-header mb-4 fw-5 text-secondary'>
                                                Create Category
                                            </h5>
                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Code
                                                </label>
                                                <input
                                                    type='text'
                                                    id='ccode'
                                                    class='form-control border-info'
                                                    name='ccode'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={e => setCode(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Name
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='cname'
                                                    id='cname'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={e => setName(e.target.value)}
                                                />
                                            </div>


                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='cdesc'
                                                    name='cdesc'
                                                    //   ref={(el) => (this.description = el)}
                                                    onChange={e => setDescription(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary form-control text-center fw-5'
                                                id='submit'
                                                onClick={CategoryCreate}
                                            >
                                                Create
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/*<!-- /.container-fluid --> */}
                    </section>
                </div>
            </div>

            {/* <!-- /.content-wrapper --> */}
            <footer className='main-footer mt-5'>
                <strong>
                    Copyright &copy; 2017-2020{' '}
                    <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
                </strong>
                All rights reserved.
            </footer>

            {/* <!-- Control Sidebar --> */}
            {/* <aside classNameName="control-sidebar control-sidebar-dark">
       
      </aside> */}
            {/* <!-- /.control-sidebar --> */}

            {/* <!-- ./wrapper --> */}
        </div>
    )
}
export default Category
